<script>
  import MarqueeTextWidget from 'svelte-marquee-text-widget';
  let paused = false;

  function toggle() {
    paused = !paused;
  }
</script>

<div class="bg-gray-100 border-b border-gray-200">
  <div
    class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-12 lg:px-8 lg:flex
    lg:items-center lg:justify-between">
    <h2
      class="text-3xl leading-9 font-extrabold tracking-tight text-gray-900
      sm:text-3xl sm:leading-10">
      svelte-marquee-text-widget
      <br />
      <span class="font-normal text-gray-500">
        <a
          href="https://www.smashingmagazine.com/2016/12/gpu-animation-doing-it-right/"
          class="text-indigo-600">
          [CSS GPU Animation]
        </a>
        Marquee Text Widget for Svelte
      </span>
      <div class="flex mt-4">
        <img
          src="https://img.shields.io/npm/v/svelte-marquee-text-widget.svg?style=for-the-badge"
          alt="svelte-marquee-text-widget npm" />
        <img
          src="https://img.shields.io/github/license/mashape/apistatus.svg?style=for-the-badge"
          alt="svelte-marquee-text-widget license"
          class="ml-1" />
        <img
          src="https://img.shields.io/npm/dt/svelte-marquee-text-widget.svg?style=for-the-badge"
          alt="svelte-marquee-text-widget downloads"
          class="ml-1" />
      </div>
    </h2>
    <div class="mt-8 flex lg:flex-shrink-0 lg:mt-0">
      <div class="inline-flex rounded-md shadow">
        <a
          href="https://github.com/borakilicoglu/svelte-marquee-text-widget"
          class="inline-flex items-center justify-center px-5 py-1 border
          border-transparent text-base leading-6 font-medium rounded-md
          text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none
          focus:shadow-outline transition duration-150 ease-in-out">
          Github
        </a>
      </div>
    </div>
  </div>
</div>

<div
  class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-12 lg:px-8 lg:flex-row
  overflow-x-auto lg:items-center lg:justify-between">

  <h2
    class="text-3xl leading-9 font-normal tracking-tight mb-4 sm:text-3xl
    sm:leading-10">
    Props
  </h2>

  <div
    class="align-middle inline-block min-w-full shadow overflow-hidden
    sm:rounded-lg border-b border-gray-200">
    <table class="min-w-full">
      <thead class="bg-gray-100">
        <tr>
          <th
            class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left
            text-xs leading-4 font-extrabold text-gray-500 uppercase
            tracking-wider">
            Name
          </th>
          <th
            class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left
            text-xs leading-4 font-extrabold text-gray-500 uppercase
            tracking-wider">
            Description
          </th>
          <th
            class="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left
            text-xs leading-4 font-extrabold text-gray-500 uppercase
            tracking-wider">
            Config
          </th>
        </tr>
      </thead>
      <tbody class="bg-white">
        <tr>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-bold text-gray-900">
                duration
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-medium text-gray-900">
                Animation Duration
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-medium text-gray-900">
                <span
                  class="px-2 inline-flex text-xs leading-5 font-semibold
                  rounded-full bg-indigo-100 text-indigo-800">
                  type: Number, default: 15
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-bold text-gray-900">
                repeat
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-medium text-gray-900">
                Number of repeat the Slot (It's important for to short content)
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-medium text-gray-900">
                <span
                  class="px-2 inline-flex text-xs leading-5 font-semibold
                  rounded-full bg-indigo-100 text-indigo-800">
                  type: Number, default: 2
                </span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-bold text-gray-900">
                paused
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-medium text-gray-900">
                The property specifies whether the animation is running or
                paused
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
            <div class="flex items-center">
              <div class="text-sm leading-5 font-medium text-gray-900">
                <span
                  class="px-2 inline-flex text-xs leading-5 font-semibold
                  rounded-full bg-indigo-100 text-indigo-800">
                  type: Boolean, default: false
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div
  class="max-w-screen-xl mx-auto bg-gray-50 py-12 px-4 sm:px-6 lg:py-12 lg:px-8">
  <div class="lg:flex lg:items-center lg:justify-between mb-4">
    <h2
      class="text-3xl leading-9 font-normal tracking-tight sm:text-3xl
      sm:leading-10">
      Demo
    </h2>
    <div class="mt-8 flex lg:flex-shrink-0 lg:mt-0">
      <div class="inline-flex rounded-md shadow">
        <button
          on:click={() => toggle()}
          class="inline-flex items-center justify-center px-5 py-1 border
          border-transparent text-base leading-6 font-medium rounded-md
          text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none
          focus:shadow-outline transition duration-150 ease-in-out">
          {#if paused}
            <span>Play</span>
          {:else}
            <span>Pause</span>
          {/if}
        </button>
      </div>
    </div>
  </div>
  <div
    class="lg:flex lg:items-center lg:justify-between sm:rounded-lg border
    border-gray-200 shadow">
    <MarqueeTextWidget {paused} duration={45}>
      <p class="bg-gray-100 py-2 text-xs">
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,38%
        </span>
        ATX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,16%
        </span>
        DAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,04%
        </span>
        TecDax
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,19%
        </span>
        MDAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        ESTX50
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,00%
        </span>
        NIKKEI
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        EUR/CHF
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,38%
        </span>
        ATX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,16%
        </span>
        DAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,04%
        </span>
        TecDax
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,19%
        </span>
        MDAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        ESTX50
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,00%
        </span>
        NIKKEI
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        EUR/CHF
      </p>
    </MarqueeTextWidget>
  </div>
  <div
    class="lg:flex lg:items-center lg:justify-between sm:rounded-lg border
    border-gray-200 mt-2 shadow">
    <MarqueeTextWidget {paused} duration={10}>
      <p class="bg-gray-100 py-2 text-xs">
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,38%
        </span>
        ATX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,16%
        </span>
        DAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,04%
        </span>
        TecDax
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,19%
        </span>
        MDAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        ESTX50
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,00%
        </span>
        NIKKEI
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        EUR/CHF
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,38%
        </span>
        ATX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,16%
        </span>
        DAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,04%
        </span>
        TecDax
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,19%
        </span>
        MDAX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        ESTX50
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,00%
        </span>
        NIKKEI
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,03%
        </span>
        EUR/CHF
      </p>
    </MarqueeTextWidget>
  </div>
</div>

<div
  class="max-w-screen-xl mx-auto bg-gray-50 py-12 px-4 sm:px-6 lg:py-12 lg:px-8">
  <div class="lg:flex-row lg:items-center lg:justify-between mb-4">
    <h2
      class="text-3xl leading-9 font-normal tracking-tight sm:text-3xl
      sm:leading-10 mb-4">
      To Small Content
    </h2>
    <p class="font-semibold">
      use prop
      <span
        class="px-2 inline-flex leading-5 rounded-full bg-indigo-100
        text-indigo-800">
        repeat="NUMBER"
      </span>
      when you know the content is not wider than
    </p>
    <p class="italic">parent Default we clone default slot two times</p>
  </div>

  <div
    class="lg:flex lg:items-center lg:justify-between sm:rounded-lg border
    border-gray-200 bg-gray-100 shadow">
    <MarqueeTextWidget duration={1}>
      <p class="bg-gray-100 py-2 text-xs">
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,38%
        </span>
        ATX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,16%
        </span>
        DAX
      </p>
    </MarqueeTextWidget>
  </div>

  <p class="font-semibold my-4">
    after add prop
    <span
      class="px-2 inline-flex leading-5 rounded-full bg-indigo-100
      text-indigo-800">
      repeat="10"
    </span>
  </p>

  <div
    class="lg:flex lg:items-center lg:justify-between sm:rounded-lg border
    border-gray-200 bg-gray-100 mt-2 shadow">
    <MarqueeTextWidget repeat={10} duration={1}>
      <p class="bg-gray-100 py-2 text-xs">
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,38%
        </span>
        ATX
        <span
          class="ml-2 px-2 inline-flex text-xs leading-5 font-semibold
          rounded-full bg-indigo-200 text-indigo-800">
          0,16%
        </span>
        DAX
      </p>
    </MarqueeTextWidget>
  </div>
</div>
